import React from "react";
import MiniTrendChart from "./MiniTrendChart";
import styles from "./InventorySummaryCard.module.css";

const DEFAULT_COLOR = "#3158df";

const hasTrendData = ({ graphData, graphType }) => {
  if (!Array.isArray(graphData) || !graphData.length) return false;
  if (graphType === "line") return Boolean(graphData[0]?.data?.length);
  return graphType === "bar";
};

const InventorySummaryCard = ({
  cardData,
  loading = false,
  onClick = cardData.handleCardClick,
}) => {
  const {
    heading,
    count,
    accentColor = DEFAULT_COLOR,
    graphData,
    graphType,
  } = cardData;

  const isInteractive = Boolean(onClick) && !loading;
  const showTrend = !loading && hasTrendData(cardData);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick();
    }
  };

  const interactiveProps = isInteractive
    ? { role: "button", tabIndex: 0, onClick, onKeyDown: handleKeyDown }
    : {};

  return (
    <div
      className={`${styles.card} ${isInteractive ? styles.clickable : ""}`}
      style={{ "--accent": accentColor }}
      {...interactiveProps}
    >
      <p className={styles.title}>{heading}</p>

      <div
        className={`${styles.body} ${showTrend ? styles.withTrend : styles.valueOnly}`}
      >
        {loading ? (
          <div className={styles.skeleton} role="status" aria-label="Loading" />
        ) : (
          <>
            <div className={styles.metric}>
              <strong className={styles.value}>
                {Number(count || 0).toLocaleString()}
              </strong>
            </div>

            {showTrend && (
              <div
                className={styles.trend}
                role="img"
                aria-label={`${heading} trend`}
              >
                <MiniTrendChart
                  data={graphData}
                  type={graphType}
                  color={accentColor}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InventorySummaryCard;
